export default "__VITE_ASSET__BDwrjwtQ__"